<template>
    <div class="main-content">
        <list
            :columns="columns"
            :rows="rows"
        />
    </div>
</template>

<script>
export default {
    name: 'HappinessFeedbacks',
    components: {
        List: () => import('@/components/List/List'),
    },
    data () {
        return {
            columns: [
                {
                    label: 'Name',
                    field: 'name',
                },
                {
                    label: 'Span',
                    field: 'span',
                    html: true,
                },
                {
                    label: 'Percent',
                    field: 'score',
                    type: 'percentage',
                },
                {
                    label: 'Created On',
                    field: 'createdAt',
                    type: 'date',
                    dateInputFormat: 'yyyy-mm-dd',
                    dateOutputFormat: 'dd/mm/yyyy',
                },
                {
                    label: 'Ações',
                    field: 'button',
                    html: true,
                    tdClass: 'text-right',
                    thClass: 'text-right',
                },
            ],
            rows: [
                {
                    id: 1,
                    name: 'John',
                    span: '<span class="badge badge-primary">Primary</span>',
                    createdAt: '2019-10-29',
                    score: 0.03343,
                },
                {
                    id: 2,
                    name: 'Jane',
                    span: '<span class="badge badge-danger">Primary</span>',
                    createdAt: '2011-10-31',
                    score: 0.03343,
                },
                {
                    id: 3,
                    name: 'Susan',
                    span: '<span class="badge badge-warning">Primary</span>',
                    createdAt: '2011-10-30',
                    score: 0.03343,
                },
                {
                    id: 4,
                    name: 'Chris',
                    span: '<span class="badge badge-primary">Primary</span>',
                    createdAt: '2011-10-11',
                    score: 0.03343,
                },
                {
                    id: 5,
                    name: 'Dan',
                    span: '<span class="badge badge-danger">Primary</span>',
                    createdAt: '2011-10-21',
                    score: 0.03343,
                },
                {
                    id: 6,
                    name: 'John',
                    span: '<span class="badge badge-success">success</span>',
                    createdAt: '2011-10-31',
                    score: 0.03343,
                },
                {
                    id: 1,
                    name: 'John',
                    span: '<span class="badge badge-warning">Warning</span>',
                    createdAt: '2019-10-29',
                    score: 0.03343,
                },
                {
                    id: 2,
                    name: 'Jane',
                    span: '<span class="badge badge-info">Info</span>',
                    createdAt: '2011-10-31',
                    score: 0.03343,
                },
                {
                    id: 3,
                    name: 'Susan',
                    span: '<span class="badge badge-dark">Dark</span>',
                    createdAt: '2011-10-30',
                    score: 0.03343,
                },
                {
                    id: 4,
                    name: 'Chris',
                    span: '<span class="badge badge-warning">Warning</span>',
                    createdAt: '2011-10-11',
                    score: 0.03343,
                },
                {
                    id: 5,
                    name: 'Dan',
                    span: '<span class="badge badge-info">Info</span>',
                    createdAt: '2011-10-21',
                    score: 0.03343,
                },
                {
                    id: 6,
                    name: 'John',
                    span: '<span class="badge badge-primary">Primary</span>',
                    createdAt: '2011-10-31',
                    score: 0.03343,
                },
            ],
        }
    },
}
</script>
